import ClassName from 'clsx'
import Styles from './style.module.scss'

interface ImageWrapperProps {
  background: string
  mask: string
  backgroundImage: string
  className: string
  children: React.ReactNode
  style: React.CSSProperties
}

export default function ImageWrapper({
  background,
  mask,
  backgroundImage,
  className,
  style,
  children,
}: Partial<ImageWrapperProps>) {
  const backgroundStyle = `${mask ? `${mask}, ` : ''}${
    backgroundImage ? `url(${backgroundImage}) no-repeat center center / cover` : ''
  }`

  return (
    <div
      className={ClassName(Styles.wrapper, className)}
      style={{ ...style, background: background || backgroundStyle }}
    >
      {children}
    </div>
  )
}
